var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX310Linkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.82,
    height: 37.82,
    viewBox: "0 0 37.82 37.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0.Linkedin",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M62.741,61.16V47.308c0-6.808-1.466-12.008-9.408-12.008a8.209,8.209,0,0,0-7.422,4.066h-.095V35.915H38.3V61.16h7.848V48.632c0-3.309.615-6.477,4.68-6.477,4.018,0,4.066,3.735,4.066,6.666V61.112h7.848Z",
    transform: "translate(-14.921 -13.339)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M11.3,36.6h7.848V61.845H11.3Z",
    transform: "translate(-0.685 -14.025)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M14.538,10a4.562,4.562,0,1,0,4.538,4.538A4.54,4.54,0,0,0,14.538,10Z",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX310Linkedin);
export default __webpack_public_path__ + "static/media/_x31_0.Linkedin.94c67393259c8b8e58c15300526ec9b9.svg";
export { ForwardRef as ReactComponent };